import {useEffect, useRef, useState} from 'react';

// use this hook to determine if something is currently visible on screen
export const useIsVisible = (ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting));
    if (ref && ref.current) observer.current.observe(ref.current);
    return () => {
      observer.current.disconnect();
    };
  }, []);
  return isVisible;
};
